// extracted by mini-css-extract-plugin
export default {"JobAds":"LocalBizAds_JobAds__ndAUs","close_button":"LocalBizAds_close_button__BjuOm","ads_mod":"LocalBizAds_ads_mod__3I8jO","fav_pop_up":"LocalBizAds_fav_pop_up__aFcek"};